import React, { useRef } from "react";
import styled from "styled-components";
import { ClickAwayListener } from "@mui/material";
import Popper from "../../../global/popper/Popper";
import FlapContainerContent from "../../../global/common/FlapOutContainer";

const FlapContainer = styled.div<{ selected: boolean }>`
  position: relative;
  color: ${(props) =>
    props.selected ? props.theme.colors.primary1 : props.theme.colors.grays1};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.selected ? props.theme.colors.misc2 : props.theme.colors.white};
  &:hover {
    background-color: ${(props) =>
      props.selected ? props.theme.colors.misc2 : props.theme.colors.misc2};
    cursor: pointer;
  }
`;

interface FlapOutProps {
  mainComponent: JSX.Element;
  children: JSX.Element[];
  flapAlignRight?: boolean;
}

const CustomFlapOut = (props: FlapOutProps): React.ReactElement => {
  const [open, setOpen] = React.useState(false);
  const ref = useRef(null);

  return (
    <FlapContainer ref={ref} selected={open} onClick={() => setOpen(!open)}>
      {props.mainComponent}
      <Popper
        placement={props.flapAlignRight ? "right" : undefined}
        anchorEl={ref.current}
        open={open}
      >
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <FlapContainerContent>{props.children}</FlapContainerContent>
        </ClickAwayListener>
      </Popper>
    </FlapContainer>
  );
};

export default CustomFlapOut;
